const GridElementContainer = ({ className = '', titleClassName = '', title, children }) => {
  return (
    <div
      className={`${className} bg-[#feebdd] rounded-[4px] p-[10px] flex flex-col items-start justify-start`}
    >
      <h3
        className={`bg-primary-75 font-bold leading-[24px] px-[10px] text-white rounded-br-xl rounded-bl rounded-t mb-[10px] w-full ${titleClassName}`}
      >
        {title}
      </h3>

      {children}
    </div>
  )
}

export default GridElementContainer
